import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InvoiceForm from "../Forms/InvoiceForm";

function AddInvoiceModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="add-community-modal"
            className='add-community-modal'
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className='text-uppercase' id="add-community-modal">
                    New Invoice
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                 <InvoiceForm />
            </Modal.Body>
            <Modal.Footer>
                {/* <Button className='btn btn-update text-uppercase' onClick={props.onHide}>update</Button> */}
            </Modal.Footer>
        </Modal>
    );
}


export default AddInvoiceModal;